module.exports = __webpack_public_path__ + "static/img/home_commission_2.3230577.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_commission_2.png
// module id = HbDu
// module chunks = 0